import { render, staticRenderFns } from "./ReviewSkill.vue?vue&type=template&id=3a4f0d4c&scoped=true"
import script from "./ReviewSkill.vue?vue&type=script&lang=js"
export * from "./ReviewSkill.vue?vue&type=script&lang=js"
import style0 from "./ReviewSkill.vue?vue&type=style&index=0&id=3a4f0d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f0d4c",
  null
  
)

export default component.exports